import { siteInfo } from "@/mocks/site";

export default function VoiceSection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.4fr] lg:gap-14">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              瓜友怎么说
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              {siteInfo.tagline}。比起单向推送，我们更在意讨论本身——
              同一件事，不同的人看到的东西本来就不一样。
            </p>
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-chat-quote-line text-xl"></i>
              </span>
              <p className="text-sm leading-6 text-foreground-700">
                每天都有新的吃瓜话题在讨论区冒出来，欢迎你也来说两句。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {siteInfo.testimonials.map((item, index) => (
              <figure
                key={item.name}
                className={`flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 ${
                  index === 2 ? "sm:col-span-2 lg:col-span-1" : ""
                }`}
              >
                <i className="ri-double-quotes-l text-2xl text-primary-400"></i>
                <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-700">
                    {item.name.slice(0, 1)}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-medium text-foreground-950">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}